// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.install-prompt {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  max-width: 576px;
  width: calc(100% - 24px);
  z-index: 1000;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
  background: #fff;
  border: 1px solid #e8e8e8;
}
.install-prompt--android {
  bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
}
.install-prompt--ios {
  bottom: calc(env(safe-area-inset-bottom, 0px) + 16px);
  padding: 14px 14px 18px;
  text-align: center;
}
.install-prompt__body {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
.install-prompt__icon {
  font-size: 22px;
  color: #002855;
  flex-shrink: 0;
}
.install-prompt__text {
  font-size: 13px;
  color: #333;
  line-height: 1.4;
}
.install-prompt__actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.install-prompt__close {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #999;
}
.install-prompt__ios-body {
  padding: 4px 8px 0;
}
.install-prompt__ios-share {
  font-size: 16px;
  vertical-align: middle;
  color: #0070f3;
}
.install-prompt__ios-arrow {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
  filter: drop-shadow(0 2px 1px rgba(0, 0, 0, 0.06));
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./src/components/InstallPrompt/index.less"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,yBAAA;ACCD;ADCC;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;ACCF;ADEC;EACC,qDAAA;EACA,uBAAA;EACA,kBAAA;ACAF;ADGC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;ACDF;ADIC;EACC,eAAA;EACA,cAAA;EACA,cAAA;ACFF;ADKC;EACC,eAAA;EACA,WAAA;EACA,gBAAA;ACHF;ADMC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;ACJF;ADOC;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;ACLF;ADQC;EACC,kBAAA;ACNF;ADSC;EACC,eAAA;EACA,sBAAA;EACA,cAAA;ACPF;ADUC;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,2BAAA;EACA,kDAAA;ACRF;AACA,oCAAoC","sourcesContent":[".install-prompt {\n\tposition: fixed;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tmax-width: 576px;\n\twidth: calc(100% - 24px);\n\tz-index: 1000;\n\tborder-radius: 12px;\n\tbox-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);\n\tbackground: #fff;\n\tborder: 1px solid #e8e8e8;\n\n\t&--android {\n\t\tbottom: 16px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tpadding: 12px 14px;\n\t}\n\n\t&--ios {\n\t\tbottom: calc(env(safe-area-inset-bottom, 0px) + 16px);\n\t\tpadding: 14px 14px 18px;\n\t\ttext-align: center;\n\t}\n\n\t&__body {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\tflex: 1;\n\t\tmin-width: 0;\n\t}\n\n\t&__icon {\n\t\tfont-size: 22px;\n\t\tcolor: #002855;\n\t\tflex-shrink: 0;\n\t}\n\n\t&__text {\n\t\tfont-size: 13px;\n\t\tcolor: #333;\n\t\tline-height: 1.4;\n\t}\n\n\t&__actions {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t\tflex-shrink: 0;\n\t}\n\n\t&__close {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tright: 8px;\n\t\tcolor: #999;\n\t}\n\n\t&__ios-body {\n\t\tpadding: 4px 8px 0;\n\t}\n\n\t&__ios-share {\n\t\tfont-size: 16px;\n\t\tvertical-align: middle;\n\t\tcolor: #0070f3;\n\t}\n\n\t&__ios-arrow {\n\t\tposition: absolute;\n\t\tbottom: -10px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-left: 10px solid transparent;\n\t\tborder-right: 10px solid transparent;\n\t\tborder-top: 10px solid #fff;\n\t\tfilter: drop-shadow(0 2px 1px rgba(0, 0, 0, 0.06));\n\t}\n}\n",".install-prompt {\n  position: fixed;\n  left: 50%;\n  transform: translateX(-50%);\n  max-width: 576px;\n  width: calc(100% - 24px);\n  z-index: 1000;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);\n  background: #fff;\n  border: 1px solid #e8e8e8;\n}\n.install-prompt--android {\n  bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 14px;\n}\n.install-prompt--ios {\n  bottom: calc(env(safe-area-inset-bottom, 0px) + 16px);\n  padding: 14px 14px 18px;\n  text-align: center;\n}\n.install-prompt__body {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n.install-prompt__icon {\n  font-size: 22px;\n  color: #002855;\n  flex-shrink: 0;\n}\n.install-prompt__text {\n  font-size: 13px;\n  color: #333;\n  line-height: 1.4;\n}\n.install-prompt__actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n.install-prompt__close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  color: #999;\n}\n.install-prompt__ios-body {\n  padding: 4px 8px 0;\n}\n.install-prompt__ios-share {\n  font-size: 16px;\n  vertical-align: middle;\n  color: #0070f3;\n}\n.install-prompt__ios-arrow {\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid #fff;\n  filter: drop-shadow(0 2px 1px rgba(0, 0, 0, 0.06));\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
